// Temporarily comment out auth-sdk import to test basic setup
// import { CookieManager } from '@repo/auth-sdk';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppRouter } from "./routes/AppRouter";
import { ThemeProvider } from "./theme/ThemeProvider";
import { Toaster } from "react-hot-toast";

// // Configure the auth SDK for development/production
// CookieManager.configure({
//   authDomain: import.meta.env.PROD ? 'https://auth.yourcompany.com' : 'http://localhost:3000',
//   cookieDomain: import.meta.env.PROD ? '.yourcompany.com' : 'localhost',
//   isDevelopment: !import.meta.env.PROD,
//   roleRedirectMapping: {
//     'admin': import.meta.env.PROD ? 'https://admin.yourcompany.com' : 'http://localhost:3001',
//     'crm_user': import.meta.env.PROD ? 'https://crm.yourcompany.com' : 'http://localhost:3002',
//     'agent': import.meta.env.PROD ? 'https://crm.yourcompany.com' : 'http://localhost:3002',
//     'student': import.meta.env.PROD ? 'https://students.yourcompany.com' : 'http://localhost:3003',
//     'eglope_user': import.meta.env.PROD ? 'https://eglope.yourcompany.com' : 'http://localhost:3004'
//   }
// });

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppRouter />

        <Toaster position="bottom-right" />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
